import React from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import Button from "../../Button";
import { useNavigate } from "react-router-dom";
import { numberToOrdinal } from "../../../../helpers/common.helper";

const _prefix = "chat-tendering__work-submitted";

const WorkSubmitted = ({ tenderingId, submission, resubmitted }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(
      `/tenderings/${tenderingId}/documents/payment-terms?no=${submission.no}`
    );
  };

  let submissionName = `${numberToOrdinal(submission.no + 1)} payment`;

  if (submission.final) {
    submissionName = "Final payment";
  }

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <div className={`${_prefix}__desc`}>
          <span className={`${_prefix}__desc__text`}>
            {submissionName} work has been{" "}
            {resubmitted ? "resubmitted" : "submitted"}
          </span>
        </div>
        <Button label={"View submission"} size="small" onClick={handleClick} />
      </div>
    </MessageContainer>
  );
};

WorkSubmitted.propTypes = {};

export default WorkSubmitted;
